import { IconButton, InputAdornment, Stack } from "@mui/material";
import useOrderStore from "../../../stores/useOrderStore";
import update from "../../../api/auth/orders/update";
import { useState } from "react";
import WushTextField from "../../form/WushTextField";
import { Save } from "@mui/icons-material";

export default function EditableAdminComments({ order }) {
  const [adminComments, setAdminComments] = useState(order.admin_comments);
  const { updateOrder } = useOrderStore();

  const handleUpdate = () => {
    update(order.id, { admin_comments: adminComments }, (response) => {
      updateOrder(response);
    });
  };

  return( 
    <Stack>
      <WushTextField
        label="Admin Comments"
        value={adminComments}
        formRegistration={{
          onChange: (e) => setAdminComments(e.target.value),
          onBlur: handleUpdate,
        }}
        multiline
        inputEndAdornment={<InputAdornment>
          <IconButton
            disabled={order.admin_comments === adminComments}
            onClick={handleUpdate}
          >
            <Save onClick={handleUpdate} />
          </IconButton>
        </InputAdornment>}
      />
    </Stack>
  );
}